import { useCubeQuery } from '@cubejs-client/react';
import { CuriosityNamespaceType, CuriosityValue } from '@procureai/curiosity-ui-mui';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { CubeQueryData } from '@/legacy/common/types';
import { DimContractField } from '@/legacy/common/types/cubes/DimContract';
import { BaseDetailHeader, BaseDetailHeaderProps } from '~/components/BaseDetailHeader/BaseDetailHeader';

export interface ContractDetailHeaderProps {
  id: string;
  tabs?: BaseDetailHeaderProps['tabs'];
  actionsRight?: ReactNode;
}

export const ContractDetailHeader = ({ id, tabs, actionsRight }: ContractDetailHeaderProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'ContractDetail' });
  const contractDetailsQuery = useCubeQuery<CubeQueryData>({
    filters: [
      {
        member: DimContractField.ID,
        operator: 'equals',
        values: [id],
      },
    ],
    dimensions: [
      DimContractField.PRIMARY_SOURCE_REFERENCE,
      DimContractField.IS_ACTIVE,
      DimContractField.PLANNED_VALUE,
      DimContractField.SUPPLIER_ID,
    ],
  });
  const loading = contractDetailsQuery.isLoading;
  const rawData = contractDetailsQuery.resultSet?.rawData();
  const supplierId = rawData?.[0]?.[DimContractField.SUPPLIER_ID];
  const primarySourceReference = rawData?.[0]?.[DimContractField.PRIMARY_SOURCE_REFERENCE];

  return (
    <BaseDetailHeader
      loading={loading}
      title={t('title', { id: primarySourceReference })}
      center={supplierId && <CuriosityValue ns={CuriosityNamespaceType.SUPPLIER} i18nKey={supplierId} />}
      tabs={tabs}
      actionsRight={actionsRight}
    />
  );
};
